<h3 class="panel-title">Selected Files</h3>

<div class="chipster-highlight">
  <!-- single file -->
  @if (selectionService.selectedDatasets.length === 1) {
    <div>
      <!-- file name -->
      @if (selectionService.selectedDatasets.length === 1) {
        <span class="h6">{{ datasetName }}</span>
      }

      <!-- context dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          type="button"
          class="btn btn-sm ms-1 btn-outline-dark no-caret-dropdown dropdown-menu-button"
          id="fileDropdownMenuButton"
          ngbDropdownToggle
          aria-haspopup="true"
          aria-expanded="false"
          title="Actions">
          <!-- <i class="fa-solid fa-bars" aria-hidden="true"></i> -->
          <i class="fas fa-lg fa-ellipsis-h" aria-hidden="true"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="fileDropdownMenuButton">
          <button ngbDropdownItem (click)="renameDataset()">Rename&hellip;</button>
          <button ngbDropdownItem (click)="wrangleDataset()">Convert to Chipster format&hellip;</button>
          <button ngbDropdownItem (click)="defineDatasetGroups()">Define samples&hellip;</button>
          <div
            class="dropdown-submenu position-relative"
            (mouseenter)="labelsSubmenuOpen = true"
            (mouseleave)="labelsSubmenuOpen = false">
            <button ngbDropdownItem class="d-flex justify-content-between align-items-center">
              <span>Labels</span>
              <span aria-hidden="true">&rsaquo;</span>
            </button>
            @if (labelsSubmenuOpen) {
              <div class="dropdown-menu show" style="position: absolute; left: 100%; top: 0; margin-left: 0">
                @for (item of labelMenuItems; track item.label.labelId) {
                  <button ngbDropdownItem (click)="toggleLabel(item)">
                    <ch-label-menu-item-content [item]="item"></ch-label-menu-item-content>
                  </button>
                }
                @if (labelMenuItems.length > 0) {
                  <div class="dropdown-divider"></div>
                }
                <button ngbDropdownItem (click)="manageLabels()">Edit labels&hellip;</button>
              </div>
            }
          </div>
          <button ngbDropdownItem (click)="exportDatasets()">Export</button>
          <button ngbDropdownItem (click)="showHistory()">History&hellip;</button>
          <div class="dropdown-divider"></div>
          <button ngbDropdownItem (click)="showJob()" [disabled]="sourceJob == null">Show job</button>
          <button ngbDropdownItem (click)="selectChildren()">Select descendants</button>
          <button ngbDropdownItem (click)="copyToNewSession()">Copy to new session&hellip;</button>
          <button ngbDropdownItem (click)="copyToExistingSession()">Copy to existing session&hellip;</button>
          <div class="dropdown-divider"></div>
          <button ngbDropdownItem (click)="deleteDatasets()">Delete</button>
        </div>
      </div>
    </div>
  }

  <!-- multiple files -->
  @if (selectionService.selectedDatasets.length > 1) {
    <div>
      <!-- file count -->
      @if (selectionService.selectedDatasets.length > 1) {
        <span class="h6">{{ selectionService.selectedDatasets.length }} files</span>
      }

      <!-- context dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          type="button"
          class="btn btn-sm ms-1 btn-outline-dark no-caret-dropdown dropdown-menu-button"
          id="filesDropdownMenuButton"
          ngbDropdownToggle
          aria-haspopup="true"
          aria-expanded="false"
          title="Actions">
          <i class="fas fa-lg fa-ellipsis-h" aria-hidden="true"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="filesDropdownMenuButton">
          <button ngbDropdownItem (click)="defineDatasetGroups()">Define samples&hellip;</button>
          <div
            class="dropdown-submenu position-relative"
            (mouseenter)="labelsSubmenuOpen = true"
            (mouseleave)="labelsSubmenuOpen = false">
            <button ngbDropdownItem class="d-flex justify-content-between align-items-center">
              <span>Labels</span>
              <span aria-hidden="true">&rsaquo;</span>
            </button>
            @if (labelsSubmenuOpen) {
              <div class="dropdown-menu show" style="position: absolute; left: 100%; top: 0; margin-left: 0">
                @for (item of labelMenuItems; track item.label.labelId) {
                  <button ngbDropdownItem (click)="toggleLabel(item)">
                    <ch-label-menu-item-content [item]="item"></ch-label-menu-item-content>
                  </button>
                }
                @if (labelMenuItems.length > 0) {
                  <div class="dropdown-divider"></div>
                }
                <button ngbDropdownItem (click)="manageLabels()">Edit labels&hellip;</button>
              </div>
            }
          </div>
          <button ngbDropdownItem (click)="selectChildren()">Select descendants</button>
          <button ngbDropdownItem (click)="copyToNewSession()">Copy to new session&hellip;</button>
          <button ngbDropdownItem (click)="copyToExistingSession()">Copy to existing session&hellip;</button>
          <div class="dropdown-divider"></div>
          <button ngbDropdownItem (click)="deleteDatasets()">
            Delete {{ selectionService.selectedDatasets.length }} files
          </button>
        </div>
      </div>
    </div>
  }

  <!-- visualization tabs -->
  @if (selectionService.selectedDatasets.length > 0) {
    <ch-visualizations (scrollFix)="doScrollFix.emit()" [sessionData]="sessionData" [tools]="tools"></ch-visualizations>
  }
</div>
